export default {"src":"/_next/static/media/menu.327eb508.svg","height":12,"width":18,"blurWidth":0,"blurHeight":0};